// src/stores/ui.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUiStore = defineStore('ui', () => {

  // Keep only lightweight UI state (IDs, not whole objects)
  const highlighted = ref(null)     // { id, type, by } | null

  function setHighlighted(id, by) { // payload: { id, by?: 'list'|'map' }
    if (highlighted.value?.id === id && highlighted.value?.by === by) return;
    highlighted.value = { id, by };
  }
  function clearHighlighted(by) {    // optionally gate to avoid cross-clears
    if (!by || highlighted.value?.by === by) {
      highlighted.value = null
    }
  }

  return {
    highlighted: computed(() => highlighted.value?.id),
    // List hover is styled with CSS; only map hover needs a reactive row highlight.
    highlightedFromMap: computed(() => highlighted.value?.by === 'map' ? highlighted.value.id : null),
    setHighlighted,
    clearHighlighted,
    isHighlighted(id) {
      return highlighted.value?.id === id;
    }
  };
});
